import { classNames } from 'primereact/utils';
import { useTranslation } from 'react-i18next';

import ProductsTable from './components/products-table/ProductsTable';
import styles from './ProductsPage.module.css';

const ProductsPage = () => {
  const { t } = useTranslation();

  return (
    <div className={classNames('px-3 py-4 sm:p-4 flex flex-column', styles.productsPage)}>
      <h1 className='text-2xl md:text-4xl'>{t('productsPage.heading')}</h1>

      <ProductsTable />
    </div>
  );
};

export default ProductsPage;
